// Named constants for string-literal values used across the Export Testing page.
// Values mirror the backend choices in basecamp/views/export_test_views.py.

export const ExportDocType = {
  PDF: "pdf",
  DOCX: "docx",
} as const;
export type ExportDocTypeValue = (typeof ExportDocType)[keyof typeof ExportDocType];

// Mirrors the backend statuses returned by the recent-exports endpoint.
export const ExportWorkflowStatus = {
  RUNNING: "running",
  COMPLETE: "complete",
  FAILED: "failed",
} as const;
export type ExportWorkflowStatusValue = (typeof ExportWorkflowStatus)[keyof typeof ExportWorkflowStatus];

// Mirrors api.enum.report_template_enums.ReportTemplateExportFontEnums member
// names. Used as the value the TS worker writes into exportData.exportFont.
export const ExportFont = {
  ARIAL: "ARIAL",
  CALIBRI: "CALIBRI",
  CENTURY_GOTHIC: "CENTURY_GOTHIC",
  GEORGIA: "GEORGIA",
  PUBLIC_SANS: "PUBLIC_SANS",
  TIMES_NEW_ROMAN: "TIMES_NEW_ROMAN",
} as const;
export type ExportFontValue = (typeof ExportFont)[keyof typeof ExportFont];

// Validates that a string is either a positive integer or a base64-encoded
// Relay global ID (e.g. "UmVwb3J0Ojg5" decoding to "Report:89").
const POSITIVE_INT_RE = /^[1-9]\d*$/;
const BASE64_RE = /^[A-Za-z0-9+/]+={0,2}$/;
export const isValidReportId = (raw: string): boolean => {
  const v = raw.trim();
  if (!v) return false;
  if (POSITIVE_INT_RE.test(v)) return true;
  if (!BASE64_RE.test(v) || v.length < 4) return false;
  try {
    const decoded = atob(v);
    return /^[A-Za-z]+:\d+$/.test(decoded);
  } catch {
    return false;
  }
};
